export const CONTENT_STATUS = {
  ARCHIVED: 'archived',
  VALIDATED: 'validated',
  DRAFT: 'draft',
  WAITING_TRANSLATION: 'waiting-translation',
  WAITING_VALIDATION: 'waiting-validation',
} as const;
